(function() {
  'use strict';

  // ─── Helpers ────────────────────────────────────────────────────────────────

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];
  const loading = $('#cart-loading');

  function showLoading() { loading?.classList.add('is-active'); }
  function hideLoading() { loading?.classList.remove('is-active'); }

  function formatMoney(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'USD'
    }).format(cents / 100);
  }

  // ─── Core AJAX helpers ─────────────────────────────────────────────────────

  /**
   * Update a specific line item by its key.
   * qty = 0 removes the item.
   */
  async function changeItem(key, qty) {
    showLoading();
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      if (!res.ok) throw new Error('Cart update failed');
      const cart = await res.json();
      updateCartUI(cart);
    } catch (err) {
      console.error(err);
      alert('Something went wrong. Please try again.');
    } finally {
      hideLoading();
    }
  }

  /**
   * Update the totals displayed on the page
   * without a full reload.
   */
  function updateCartUI(cart) {
    // Update totals
    const subtotal = $('#cart-subtotal-price');
    const total    = $('#cart-total-price');

    if (subtotal) subtotal.textContent = formatMoney(cart.items_subtotal_price);
    if (total)    total.textContent    = formatMoney(cart.total_price);

    // Update each line item total
    cart.items.forEach(item => {
      const lineTotal = $(`[data-line-total="${item.key}"]`);
      const totalUnitCount = $(`[data-unit-count="${ item.key }"]`);
      if (lineTotal) lineTotal.textContent = formatMoney(item.final_line_price);
      if (totalUnitCount) totalUnitCount.textContent = item.quantity;

      // Update qty input to reflect server value
      const qtyInput = $(`.qty-input[data-key="${item.key}"]`);
      if (qtyInput) qtyInput.value = item.quantity;

      // Update stepper button data-qty attributes
      const minusBtn = $(`.qty-btn[data-action="minus"][data-key="${item.key}"]`);
      const plusBtn  = $(`.qty-btn[data-action="plus"][data-key="${item.key}"]`);
      if (minusBtn) {
        minusBtn.dataset.qty = item.quantity - 1;
        minusBtn.setAttribute('aria-disabled', item.quantity <= 1 ? 'true' : 'false');
      }
      if (plusBtn) plusBtn.dataset.qty = item.quantity + 1;
    });

    // Handle items that were fully removed (qty = 0)
    $$('.v2-cart__item').forEach(el => {
      const key  = el.dataset.key;
      const live = cart.items.find(i => i.key === key);
      if (!live) {
        el.style.transition = 'opacity 0.3s';
        el.style.opacity = '0';
        setTimeout(() => {
          el.remove();
          checkIfEmpty(cart);
        }, 300);
      }
    });
  }

  /**
   * If no items remain, show the empty state
   * without navigating away.
   */
  function checkIfEmpty(cart) {
    if (cart.item_count === 0) {
      // Reload is simplest here to render the Liquid empty state
      window.location.reload();
    }
  }

  // ─── Event Delegation ──────────────────────────────────────────────────────

  const container = $('#cart-items-container');

  if (container) {
    container.addEventListener('click', (e) => {

      // ── +/- stepper buttons ──────────────────────────────────────────────
      const btn = e.target.closest('.qty-btn');
      if (btn) {
        const key = btn.dataset.key;
        const name = btn.dataset.name;
        let qty = parseInt(btn.dataset.qty, 10);
        // if(name === 'plus' && !isNaN(qty))
        //   qty += 1;
        // else if(name === 'minus'  && !isNaN(qty))
        //   qty -= 1;
        console.log(qty);
        if (!isNaN(qty) && key) changeItem(key, Math.max(0, qty));
        return;
      }

      // ── Remove button ────────────────────────────────────────────────────
      const remove = e.target.closest('.v2-cart__item-remove');
      if (remove) {
        const key = remove.dataset.key;
        if (key) changeItem(key, 0);
        return;
      }
    });

    // ── Qty input: update on blur or Enter ───────────────────────────────
    container.addEventListener('change', (e) => {
      if (!e.target.classList.contains('qty-input')) return;
      const key = e.target.dataset.key;
      const qty = parseInt(e.target.value, 10);
      if (key && !isNaN(qty) && qty >= 0) changeItem(key, qty);
    });

    container.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' && e.target.classList.contains('qty-input')) {
        e.target.blur(); // triggers change event
      }
    });
  }

  // ─── Cart Note auto-save ───────────────────────────────────────────────────
  // const noteField = $('#cart-note');
  // if (noteField) {
  //   let noteTimer;
  //   noteField.addEventListener('input', () => {
  //     clearTimeout(noteTimer);
  //     noteTimer = setTimeout(async () => {
  //       await fetch('/cart/update.js', {
  //         method: 'POST',
  //         headers: { 'Content-Type': 'application/json' },
  //         body: JSON.stringify({ note: noteField.value })
  //       });
  //     }, 800);
  //   });
  // }

})();